import { render, staticRenderFns } from "./OverseasColumn.vue?vue&type=template&id=16e8aff1&"
import script from "./OverseasColumn.vue?vue&type=script&lang=js&"
export * from "./OverseasColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports